module.exports = __webpack_public_path__ + "img/imgTooltipRu.16d6bc68.png";